import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'
import services from '@/services'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_METADATA: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/utils/info`).then(res => {
        commit('SET_METADATA', { origin: res.body, formated: services.formatMetadataForSelect(res.body) })
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_COUNTS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/admin-info`).then(res => {
        commit('UPDATE_TOTALS', res.body)
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/metadata/actions.js